import { render, staticRenderFns } from "./OrganPersonBasicInfoView.vue?vue&type=template&id=1ada4066&scoped=true"
import script from "./OrganPersonBasicInfoView.vue?vue&type=script&lang=js"
export * from "./OrganPersonBasicInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada4066",
  null
  
)

export default component.exports